var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Redirect, useLocation } from 'react-router-dom';
import loadable from '@loadable/component';
import useAuth, { AUTH_ROUTES } from '../hooks/useAuth';
export var AuthenticatedRoute = function (_a) {
    var _b = _a.roles, roles = _b === void 0 ? [] : _b, importPath = _a.importPath, props = __rest(_a, ["roles", "importPath"]);
    var _c = useAuth(), user = _c.user, isAdmin = _c.isAdmin, role = _c.role;
    var location = useLocation();
    if (AUTH_ROUTES.includes(location === null || location === void 0 ? void 0 : location.pathname)) {
        return null;
    }
    if (!user)
        return _jsx(Redirect, { to: "/login" });
    if (!isAdmin && roles.length && !(roles === null || roles === void 0 ? void 0 : roles.includes(role))) {
        return _jsx(Redirect, { to: "/" });
    }
    return _jsx(Route, __assign({}, props, { component: loadable(importPath) }));
};
AuthenticatedRoute.displayName = 'AuthenticatedRoute';
